import { mapGetters } from "vuex";
import { GET_CLIENT_Session } from "../helpers/vuex-constants";
import UserEvent from "../services/userEvent";

export default {
  computed: {
    ...mapGetters({
      userSessionId: GET_CLIENT_Session,
    }),
  },
  methods: {
    saveUserSession(pageName, action, note) {
      let payload = {
        pageName: pageName,
        action: action,
        note: note,
        sessionId: this.userSessionId,
      };
      UserEvent.saveUserSession(payload);
    },
  },
};
